/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_c_silent_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENT has three well-known full anagrams: LISTEN, ENLIST, and TINSEL, plus INLETS — all four use exactly the same six letters (S, I, L, E, N, T) rearranged. LISTEN is the most commonly cited pairing because of the contrast between the two words' meanings.`)
};

const es_wu_c_silent_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENT tiene tres anagramas completos bien conocidos: LISTEN, ENLIST y TINSEL, además de INLETS —los cuatro usan exactamente las mismas seis letras (S, I, L, E, N, T) reordenadas. LISTEN es el emparejamiento más citado por el contraste entre los significados de ambas palabras.`)
};

const de_wu_c_silent_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENT hat drei bekannte vollständige Anagramme: LISTEN, ENLIST und TINSEL, dazu INLETS — alle vier nutzen genau dieselben sechs Buchstaben (S, I, L, E, N, T) in neuer Reihenfolge. LISTEN ist die am häufigsten zitierte Paarung wegen des Gegensatzes zwischen den Bedeutungen beider Wörter.`)
};

const nl_wu_c_silent_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENT heeft drie bekende volledige anagrammen: LISTEN, ENLIST en TINSEL, plus INLETS — alle vier gebruiken exact dezelfde zes letters (S, I, L, E, N, T) in een andere volgorde. LISTEN is de meest aangehaalde combinatie vanwege het contrast tussen de betekenissen van de twee woorden.`)
};

const fr_wu_c_silent_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENT possède trois anagrammes complètes bien connues : LISTEN, ENLIST et TINSEL, ainsi qu'INLETS — les quatre utilisent exactement les mêmes six lettres (S, I, L, E, N, T) réarrangées. LISTEN est la paire la plus souvent citée en raison du contraste entre les significations des deux mots.`)
};

const it_wu_c_silent_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENT ha tre anagrammi completi ben noti: LISTEN, ENLIST e TINSEL, oltre a INLETS — tutti e quattro usano esattamente le stesse sei lettere (S, I, L, E, N, T) riordinate. LISTEN è l'abbinamento citato più spesso per il contrasto tra i significati delle due parole.`)
};

const pt_br2_wu_c_silent_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENT tem três anagramas completos bem conhecidos: LISTEN, ENLIST e TINSEL, além de INLETS — as quatro usam exatamente as mesmas seis letras (S, I, L, E, N, T) rearranjadas. LISTEN é o par mais citado por causa do contraste entre os significados das duas palavras.`)
};

const pt_wu_c_silent_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENT tem três anagramas completos bem conhecidos: LISTEN, ENLIST e TINSEL, além de INLETS — as quatro usam exatamente as mesmas seis letras (S, I, L, E, N, T) reordenadas. LISTEN é o par mais frequentemente citado, devido ao contraste entre os significados das duas palavras.`)
};

const ja_wu_c_silent_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENTにはLISTEN、ENLIST、TINSELという3つのよく知られた完全なアナグラムに加え、INLETSもあります — この4つはすべて、同じ6文字（S, I, L, E, N, T）を並べ替えたものです。LISTENが最も頻繁に引き合いに出されるのは、2つの単語の意味の対比によるものです。`)
};

const zh_wu_c_silent_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENT 有三个广为人知的完整易位构词：LISTEN、ENLIST 和 TINSEL，再加上 INLETS——这四个单词都使用完全相同的六个字母（S、I、L、E、N、T）重新排列而成。LISTEN 是被提及最多的那一对，因为这两个单词的含义形成了鲜明对比。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_c_silent_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_c_silent_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_c_silent_faq1_a", locale)
	if (locale === "en") return en_wu_c_silent_faq1_a(inputs)
	if (locale === "es") return es_wu_c_silent_faq1_a(inputs)
	if (locale === "de") return de_wu_c_silent_faq1_a(inputs)
	if (locale === "nl") return nl_wu_c_silent_faq1_a(inputs)
	if (locale === "fr") return fr_wu_c_silent_faq1_a(inputs)
	if (locale === "it") return it_wu_c_silent_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_wu_c_silent_faq1_a(inputs)
	if (locale === "pt") return pt_wu_c_silent_faq1_a(inputs)
	if (locale === "ja") return ja_wu_c_silent_faq1_a(inputs)
	return zh_wu_c_silent_faq1_a(inputs)
};